<template>
  <div>
    <div class="main-content" v-if="loader === 100">
      <div class="form-card">
        <ValidationObserver ref="formObserver" v-slot="{ invalid, validate }">
          <b-form @submit.prevent="handleSubmit(validate)" class="form-content">
            <div class="form-section">
              <ValidationProvider name="Título" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label for="titulo" class="form-label">
                    <span class="required">*</span> Título do Grupo
                  </label>
                  <b-form-input
                      id="titulo"
                      v-model="grupo.titulo"
                      :state="errors.length ? false : null"
                      placeholder="Digite o título do grupo"
                      class="form-input"
                  />
                  <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                </div>
              </ValidationProvider>
            </div>
            <div class="form-section">
              <div class="form-group">
                <label for="descricao" class="form-label">Descrição</label>
                <b-form-textarea
                    id="descricao"
                    v-model="grupo.descricao"
                    rows="4"
                    placeholder="Digite uma descrição para o grupo"
                    class="form-textarea"
                />
              </div>
            </div>

            <div class="form-section">
              <div class="form-group">
                <label for="status" class="form-label">Status</label>
                <b-form-select
                    id="status"
                    v-model="grupo.status"
                    :options="[ { value: 1, text: 'Ativo' }, { value: 0, text: 'Inativo' } ]"
                    class="form-select-status"
                />
              </div>
            </div>

            <!-- Selecao de Unidades / Paineis / Totens -->
            <div class="form-section">
              <div class="section-header">
                <h5>Unidades e Itens</h5>
                <div>
                  <b-button size="sm" variant="success" class="btn-add-section" @click="addUnidade()">
                    <i class="fas fa-plus"></i> Adicionar Unidade
                  </b-button>
                </div>
              </div>

              <div v-for="(u, idx) in grupo.unidades" :key="idx" class="unidade-painel-group mb-3">
                <div class="row">
                  <div class="col-md-8">
                    <label class="form-label">Unidade</label>
                    <v-select
                      v-model="u.unit_id"
                      :options="todasUnidades"
                      :label="'nome'"
                      :reduce="reduceUnidade"
                      class="form-select"
                      placeholder="Selecione uma unidade"
                      @input="onUnidadeChange(idx, u.unit_id)"
                    />
                  </div>
                  <div class="col-md-4 text-right">
                    <label class="form-label d-block">Ações</label>
                    <b-button size="sm" variant="danger" class="btn-remove-unit" @click="removeUnidade(idx)">
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </div>
                </div>

                <div class="mt-3">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong>Painéis</strong>
                        <div>
                          <b-button size="sm" variant="link" @click.prevent="selectAllPaineis(idx)">Selecionar todos
                          </b-button>
                          <b-button size="sm" variant="link" @click.prevent="clearPaineis(idx)">Limpar</b-button>
                        </div>
                      </div>
                      <div v-if="paineisPorUnidade[u.unit_id] && paineisPorUnidade[u.unit_id].length">
                        <div v-for="painel in paineisPorUnidade[u.unit_id]" :key="painel.id" class="form-check">
                          <input class="form-check-input" type="checkbox"
                                 :id="`painel_${idx}_${painel.id}`"
                                 :value="painel.id"
                                 v-model="u.paineis">
                          <label class="form-check-label" :for="`painel_${idx}_${painel.id}`">{{
                              painel.nome || painel.title || painel.label || painel.id
                            }}</label>
                        </div>
                      </div>
                      <div v-else class="text-muted">Selecione uma unidade para carregar painéis</div>
                    </div>

                    <div class="col-md-6">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong>Totens</strong>
                        <div>
                          <b-button size="sm" variant="link" @click.prevent="selectAllTotens(idx)">Selecionar todos
                          </b-button>
                          <b-button size="sm" variant="link" @click.prevent="clearTotens(idx)">Limpar</b-button>
                        </div>
                      </div>
                      <div v-if="totensPorUnidade[u.unit_id] && totensPorUnidade[u.unit_id].length">
                        <div v-for="totem in totensPorUnidade[u.unit_id]" :key="totem.id" class="form-check">
                          <input class="form-check-input" type="checkbox"
                                 :id="`totem_${idx}_${totem.id}`"
                                 :value="totem.id"
                                 v-model="u.totens">
                          <label class="form-check-label" :for="`totem_${idx}_${totem.id}`">{{
                              totem.nome || totem.title || totem.label || totem.id
                            }}</label>
                        </div>
                      </div>
                      <div v-else class="text-muted">Selecione uma unidade para carregar totens</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Rodapé -->
            <div class="form-footer">
              <div class="required-info">
                <span class="required">*</span>
                <span>Campos obrigatórios</span>
              </div>
              <div class="form-actions">
                <b-button variant="outline-secondary" class="btn-cancel" @click="$router.go(-1)">
                  <i class="fas fa-arrow-left"></i> Voltar
                </b-button>
                <b-button
                    type="submit"
                    variant="primary"
                    class="btn-save"
                    :disabled="!grupo.titulo || isLoading"
                >
                  <template v-if="isLoading">
                    <i class="fas fa-spinner fa-spin"></i> Salvando...
                  </template>
                  <template v-else>
                    <i class="fas fa-save"></i> Salvar
                  </template>
                </b-button>
              </div>
            </div>

          </b-form>
        </ValidationObserver>
      </div>
    </div>

    <!-- Loading -->
    <div class="loading-container" v-else>
      <div class="loading-card">
        <div class="progress-container">
          <div class="progress">
            <div
                class="progress-bar"
                role="progressbar"
                :style="'width: ' + loader + '%;'"
            ></div>
          </div>
          <div class="loading-text">
            <div class="loading-title">Carregando...</div>
            <div class="loading-percentage">{{ loader }}%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "axios";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {BButton, BForm, BFormFile, BFormInput, BFormInvalidFeedback, BFormSelect, BFormTextarea} from "bootstrap-vue";

export default {
  name: "grupoForm",
  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
    BButton,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BFormSelect,
    BFormInvalidFeedback,
  },
  data() {
    return {
      loader: 0,
      isLoading: false,
      grupo: {
        titulo: "",
        descricao: "",
        unidades: [
          {
            unit_id: null,
            paineis: [],
            totens: [],
          },
        ],
        status: 1,
      },
      todasUnidades: [],
      paineisPorUnidade: {},
      totensPorUnidade: {},
      isEdit: false,
      grupoId: null,
    };
  },
  methods: {
    async handleSubmit(validate) {
      const isValid = await validate();
      if (isValid) {
        this.save();
      }
    },

    save() {
      let api = this.$store.state.api + "grupos";
      let method = "post";

      if (this.isEdit) {
        api += "/" + this.grupoId;
        method = "put";
      }

      const unidadesValidas = this.grupo.unidades
          .filter((u) => u.unit_id && (Array.isArray(u.paineis) && u.paineis.length > 0 || Array.isArray(u.totens) && u.totens.length > 0))
          .map((u) => {
            const paineis = Array.isArray(u.paineis) ? u.paineis : [];
            const totens = Array.isArray(u.totens) ? u.totens : [];

            let itens = [];

            if (paineis.length > 0 && totens.length > 0) {
              itens = paineis.flatMap((painel_id) =>
                  totens.map((totem_id) => ({painel_id, totem_id}))
              );
            } else if (paineis.length > 0) {
              itens = paineis.map((painel_id) => ({painel_id, totem_id: null}));
            } else if (totens.length > 0) {
              itens = totens.map((totem_id) => ({painel_id: null, totem_id}));
            }

            return {
              unit_id: u.unit_id,
              itens,
            };
          });

      if (unidadesValidas.length === 0) {
        this.$message("Erro", "Selecione pelo menos uma unidade com painel ou totem", "error");
        return;
      }

      const payload = {
        nome: this.grupo.titulo,
        descricao: this.grupo.descricao,
        itens: unidadesValidas,
        status: parseInt(this.grupo.status),
      };

      this.isLoading = true;

      axios[method](api, payload)
          .then((response) => {
            this.$message("Sucesso", "Grupo criado com sucesso", "success");
            this.$router.push("/grupos");
          })
          .catch((error) => {
            this.handleApiErrors(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    handleApiErrors(error) {
      if (!error.response) {
        this.$message("Erro", "Erro de conexão. Verifique sua internet.", "error");
        return;
      }

      const {data, status} = error.response;

      if (status === 422) {
        if (data.errors) {
          const errorMessages = [];
          Object.keys(data.errors).forEach((field) => {
            const fieldErrors = Array.isArray(data.errors[field]) ? data.errors[field] : [data.errors[field]];
            fieldErrors.forEach((errorMsg) => {
              const friendlyField = this.getFriendlyFieldName(field);
              errorMessages.push(`${friendlyField}: ${errorMsg}`);
            });
          });

          if (errorMessages.length === 1) {
            this.$message("Erro", errorMessages[0], "error");
          } else {
            this.$message("Erros de Validação", `${errorMessages.length} campos precisam ser corrigidos`, "error");
          }

        } else if (data.message) {
          this.$message("Erro", data.message, "error");
        }
        return;
      }

      let errorMessage = "Erro ao salvar grupo";

      if (data.message) {
        errorMessage = data.message;
      } else if (typeof data === "string") {
        errorMessage = data;
      }

      this.$message("Erro", errorMessage, "error");
    },

    getFriendlyFieldName(field) {
      const fieldMap = {
        titulo: "Título",
        nome: "Nome",
        status: "Status",
        unidades: "Unidades",
        itens: "Itens",
      };

      if (field.includes("unidades.")) {
        const parts = field.split(".");
        if (parts.length >= 4) {
          const unidadeIndex = parseInt(parts[1]) + 1;
          const itemIndex = parseInt(parts[3]) + 1;
          const subField = parts[4];

          if (subField === "painel_id") {
            return `Painel (${unidadeIndex}ª unidade, ${itemIndex}º item)`;
          } else if (subField === "totem_id") {
            return `Totem (${unidadeIndex}ª unidade, ${itemIndex}º item)`;
          }
        } else if (parts.length >= 3) {
          const unidadeIndex = parseInt(parts[1]) + 1;
          const subField = parts[2];

          if (subField === "unit_id") {
            return `Unidade (${unidadeIndex}ª)`;
          } else if (subField === "paineis_totens") {
            return `Painéis e Totens (${unidadeIndex}ª unidade)`;
          }
        }
      }

      return fieldMap[field] || field;
    },

    getUnidades() {
      const api = this.$store.state.api + "unidades?paginated=false";
      return axios
          .get(api)
          .then((response) => {
            const raw = response.data || [];
            const unidades = Array.isArray(raw) ? raw : (Array.isArray(raw.data) ? raw.data : []);
            this.todasUnidades = unidades.map((u) => ({
              ...u,
              id: u.id || u.ID || u.unidade_id,
              nome: u.nome || u.name || u.label || `Unidade ${u.id || u.ID || u.unidade_id || ""}`,
            }));
          })
          .catch((error) => {
            this.$message("Erro", "Erro ao carregar unidades", "error");
          });
    },

    reduceUnidade(option) {
      if (!option) return null;
      return option.id || option.ID || option.unidade_id || null;
    },

    fetchGrupo(id) {
      const api = this.$store.state.api + "grupos/" + id + "?with[]=itens";

      axios
          .get(api)
          .then((response) => {
            const raw = response.data.data || response.data;
            const grupo = Array.isArray(raw) ? raw[0] : raw;

            this.grupo.titulo = grupo.nome || "";
            this.grupo.descricao = grupo.descricao || "";
            this.grupo.status = grupo.status !== undefined && grupo.status !== null ? parseInt(grupo.status) : 1;

            this.grupoId = grupo.id || this.grupoId;
            this.isEdit = !!this.grupoId;

            const itens = grupo.itens || grupo.grupo_itens || [];
            if (itens && Array.isArray(itens)) {
              const unidadesMap = {};

              itens.forEach((rel) => {
                const unidadeId = rel.unidade_id;

                if (!unidadesMap[unidadeId]) {
                  unidadesMap[unidadeId] = {
                    unit_id: unidadeId,
                    paineis: new Set(),
                    totens: new Set(),
                  };
                }

                const painelId = rel.painel_id || null;
                const totemId = rel.totem_id || null;

                if (painelId) unidadesMap[unidadeId].paineis.add(painelId);
                if (totemId) unidadesMap[unidadeId].totens.add(totemId);
              });

              this.grupo.unidades = Object.values(unidadesMap).map((unidade) => ({
                unit_id: unidade.unit_id,
                paineis: Array.from(unidade.paineis),
                totens: Array.from(unidade.totens),
              }));

              this.$nextTick(() => {
                this.grupo.unidades.forEach((u, idx) => {
                  if (u.unit_id) {
                    this.onUnidadeChange(idx, u.unit_id, true);
                  }
                });
              });
            } else {
              this.grupo.unidades = [{unit_id: null, paineis: [], totens: []}];
            }
          })
          .catch((error) => {
            this.$message("Erro", "Erro ao carregar dados do grupo", "error");
          });
    },

    setLoader(qtd) {
      let load = 0;
      let interval = setInterval(() => {
        if (this.loader < qtd) this.loader++;
        load++;
        if (load >= qtd) clearInterval(interval);
      }, 15);
    },

    initForm() {
      this.grupoId = this.$route.params.id;
      this.isEdit = !!this.grupoId;

      this.setLoader(30);

      Promise.all([this.getUnidades()])
          .then(() => {
            if (this.isEdit) {
              return this.fetchGrupo(this.grupoId);
            }
          })
          .finally(() => {
            this.loader = 100;
          });
    },

    onUnidadeChange(index, unitId, preserveSelections = false) {
      if (!preserveSelections) {
        this.$set(this.grupo.unidades, index, {
          unit_id: unitId,
          paineis: [],
          totens: [],
        });
      } else {
        this.$set(this.grupo.unidades, index, {
          unit_id: unitId,
          paineis: this.grupo.unidades[index] ? this.grupo.unidades[index].paineis || [] : [],
          totens: this.grupo.unidades[index] ? this.grupo.unidades[index].totens || [] : [],
        });
      }

      if (unitId) {
        const apiPaineis = this.$store.state.api + `paineis?paginated=false&unidade_id=${unitId}`;
        const apiTotens = this.$store.state.api + `totens?paginated=false&unidade_id=${unitId}`;

        axios
            .get(apiPaineis)
            .then((response) => {
              const paineis = response.data.data || response.data;
              if (!this.paineisPorUnidade[unitId]) {
                this.$set(this.paineisPorUnidade, unitId, []);
              }
              this.paineisPorUnidade[unitId] = paineis;
            })
            .catch((error) => {
              this.$message("Erro", "Erro ao carregar painéis da unidade", "error");
            });

        axios
            .get(apiTotens)
            .then((response) => {
              const totens = response.data.data || response.data;
              if (!this.totensPorUnidade[unitId]) {
                this.$set(this.totensPorUnidade, unitId, []);
              }
              this.totensPorUnidade[unitId] = totens;
            })
            .catch((error) => {
              this.$message("Erro", "Erro ao carregar totens da unidade", "error");
            });
      }
    },

    addUnidade() {
      this.grupo.unidades.push({unit_id: null, paineis: [], totens: []});
    },

    removeUnidade(index) {
      if (this.grupo.unidades.length > 1) {
        this.grupo.unidades.splice(index, 1);
      } else {
        this.$set(this.grupo.unidades, 0, {unit_id: null, paineis: [], totens: []});
      }
    },
    selectAllPaineis(index) {
      const unit = this.grupo.unidades[index];
      if (!unit || !unit.unit_id) return;
      const all = (this.paineisPorUnidade[unit.unit_id] || []).map(p => p.id);
      this.$set(this.grupo.unidades[index], 'paineis', all);
    },
    clearPaineis(index) {
      this.$set(this.grupo.unidades[index], 'paineis', []);
    },
    selectAllTotens(index) {
      const unit = this.grupo.unidades[index];
      if (!unit || !unit.unit_id) return;
      const all = (this.totensPorUnidade[unit.unit_id] || []).map(t => t.id);
      this.$set(this.grupo.unidades[index], 'totens', all);
    },
    clearTotens(index) {
      this.$set(this.grupo.unidades[index], 'totens', []);
    },
  },

  mounted() {
    this.initForm();
  },
};
</script>

<style scoped>
.combinations-preview {
  margin-top: 20px;
  padding: 18px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  border-left: 4px solid #17a2b8;
  border-top: 1px solid #dee2e6;
}

.combinations-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.combinations-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.combination-badge {
  padding: 8px 14px;
  border-radius: 25px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.combination-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.badge-success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border: 1px solid #c3e6cb;
}

.badge-warning {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  color: #856404;
  border: 1px solid #ffeaa7;
  animation: pulse-warning 2s infinite;
}

@keyframes pulse-warning {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.combination-badge i {
  font-size: 11px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
}

.btn-add-section {
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-add-section:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(40, 167, 69, 0.3);
}

.unidade-painel-group {
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 25px;
  background: #f8f9fa;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.unidade-painel-group:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.unidade-painel-group .row:first-child {
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 20px;
  margin-bottom: 20px;
}

.unidade-painel-group .row:first-child::after {
  content: '';
  position: absolute;
  left: 25px;
  right: 25px;
  height: 1px;
  background: linear-gradient(90deg, transparent, #667eea, transparent);
  bottom: -1px;
}

.btn-remove-unit {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.3s ease;
}

.btn-remove-unit:hover {
  background: #dc3545;
  transform: scale(1.1);
  box-shadow: 0 3px 8px rgba(220, 53, 69, 0.3);
}

.form-label i {
  margin-right: 5px;
}

.no-units-message {
  text-align: center;
  padding: 60px 20px;
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  transition: all 0.3s ease;
}

.no-units-message:hover {
  border-color: #667eea;
  background: linear-gradient(135deg, #f0f0ff 0%, #e6e6ff 100%);
}

.no-units-icon {
  font-size: 48px;
  color: #6c757d;
  margin-bottom: 15px;
}

.no-units-icon i {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.main-content {
  padding: 0;
  min-height: 100vh;
}

.form-card {
  border-radius: 12px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin: 20px;
}

.form-content {
  padding: 30px;
}

.form-section {
  margin-bottom: 30px;
}

.form-section:last-of-type {
  margin-bottom: 20px;
}

.form-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: block;
  font-size: 14px;
}

.required {
  color: #e74c3c;
  font-weight: bold;
}

.form-input, .form-textarea {
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 15px;
  transition: all 0.3s ease;
}

.form-input:focus, .form-textarea:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.15);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
}

.file-upload-container {
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.file-upload-container:hover {
  border-color: #667eea;
}

.form-file {
  border: none;
  background: transparent;
}

.file-info {
  color: #6c757d;
  display: block;
  margin-top: 8px;
  font-size: 13px;
}

.file-info i {
  margin-right: 5px;
  color: #17a2b8;
}

.form-select {
  border-radius: 8px;
}

.form-select .vs__dropdown-toggle {
  border: none;
  padding: 10px 12px;
  min-height: 48px;
}

.form-select .vs__selected-options {
  padding: 0;
}

.form-select .vs__selected {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #2c3e50;
  font-size: 15px;
}

.form-select .vs__search {
  margin: 0;
  padding: 0;
  font-size: 15px;
}

.form-select .vs__actions {
  padding: 0 8px;
}

.form-select:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.15);
}

.form-select.is-invalid {
  border-color: #e74c3c;
}

.form-select-status {
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 15px;
  transition: all 0.3s ease;
  min-height: 48px;
  height: auto;
  box-sizing: border-box;
  width: 100%;
  display: block;
}

.form-select-status:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.15);
}

.preview-container {
  border-radius: 8px;
  padding: 20px;
}

.video-preview {
  width: 100%;
  max-height: 250px;
  border-radius: 8px;
  margin-top: 10px;
  background: #000;
}

.form-footer {
  padding: 25px 30px;
  margin: 0 -30px -30px -30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.required-info {
  color: #6c757d;
  font-size: 13px;
}

.form-actions {
  display: flex;
  gap: 12px;
}

.btn-cancel {
  background: #6c757d;
  border: none;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #5a6268;
  color: white;
  transform: translateY(-1px);
}

.btn-save {
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-save:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-save:disabled {
  background: #6c757d;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 20px;
}

.loading-card {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  min-width: 300px;
}

.progress-container {
  width: 100%;
}

.progress {
  height: 8px;
  border-radius: 20px;
  background: #e9ecef;
  overflow: hidden;
  margin-bottom: 20px;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  transition: width 0.3s ease;
}

.loading-text {
  color: #2c3e50;
}

.loading-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}

.loading-percentage {
  font-size: 24px;
  font-weight: bold;
  color: #667eea;
}

.invalid-feedback {
  color: #e74c3c;
  font-size: 13px;
  margin-top: 5px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .form-card {
    margin: 10px;
  }

  .form-content {
    padding: 20px;
  }

  .form-footer {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .form-actions {
    width: 100%;
    justify-content: center;
  }

  .section-header {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }

  .combinations-list {
    flex-direction: column;
    gap: 8px;
  }

  .combination-badge {
    text-align: center;
    justify-content: center;
  }

  .btn-remove-unit {
    margin-top: 10px;
  }

  .unidade-painel-group {
    padding: 20px;
    margin-bottom: 20px;
  }

  .unidade-painel-group .row:first-child {
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
}
</style>
